import React from "react";
import PropTypes from "prop-types";
import { Field } from "redux-form";
import { AutoCompleteField } from "MODULES/shared/components/Forms";
import { THIRD_BUYER_ID } from "MODULES/users/constants";

export default function ThirdBuyerField({
  buyerCreditPct,
  disabled = false,
  numberOfBuyers,
  searchBuyers,
  selectedThirdBuyer,
  toggleBuyer
}) {
  if ([25, 50].includes(parseFloat(buyerCreditPct)) || numberOfBuyers < 2) {
    return null;
  }

  return (
    <Field
      name={THIRD_BUYER_ID}
      label="Third Buyer and Credit"
      placeholder="Search by name..."
      component={AutoCompleteField}
      search={searchBuyers}
      selectedItem={selectedThirdBuyer}
      onItemSelected={item => toggleBuyer({ selectedThirdBuyer: item })}
      formatItem={result => result && result.full_name}
      append={
        selectedThirdBuyer ? (
          <span>{parseInt(buyerCreditPct / numberOfBuyers, 10)}%</span>
        ) : null
      }
      disabled={disabled}
    />
  );
}

ThirdBuyerField.propTypes = {
  buyerCreditPct: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  numberOfBuyers: PropTypes.string.isRequired,
  searchBuyers: PropTypes.func.isRequired,
  selectedThirdBuyer: PropTypes.instanceOf(Object),
  toggleBuyer: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/CoBuyersFields/ThirdBuyerField.jsx